// extracted by mini-css-extract-plugin
module.exports = {"content-with-sources__sources":"ContentWithSources_content-with-sources__sources__fiQox"};